/*
 * @Date: 2023-06-07 11:41:52
 * @LastEditors: teenagex
 * @LastEditTime: 2023-07-12 15:29:37
 */
import { createRouter, createWebHistory } from 'vue-router';
// 1、引入组件
import Home from "../view/Home.vue"
import DestroyAccount from "../view/DestroyAccount.vue"
import Signin from "../view/Signin.vue"
import HomeAssistant from "../view/HomeAssistant.vue"
import HomeAssistant2 from "../view/HomeAssistant2.vue"
import AuthToken from "../view/AuthToken.vue"
/**
 * 2、配置路由映射关系
 */
const routes = [
  {
    path: '/',
    name: 'app',
    redirect: "/home"
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: "首页",
      requireAuth: true,
    }
  },
  {
    path: "/signin",
    name: 'signin',
    component: Signin
  },
  {
    path: "/auth_token/:token",
    name: 'auth_token',
    component: AuthToken,
  },
  {
    path: "/destroy_account",
    name: 'destroy_account',
    component: DestroyAccount,
    meta: {
      title: "注销账号",
      requireAuth: true,
    }
  },
  {
    path: "/home_assistant",
    name: 'home_assistant',
    component: HomeAssistant,
    meta: {
      title: "Home Assistant",
      requireAuth: false,
    }
  },
  {
    path: "/home_assistant2",
    name: 'home_assistant2',
    component: HomeAssistant2,
    meta: {
      title: "Home Assistant 2",
      requireAuth: true,
    }
  },
  {
    path: "/:pathMatch(.*)",
    name: "404",
    component: () => import("../view/NotFound.vue")
  }
]
const router = createRouter({
  // 指定模式
  /**
   * createWebHashHistory 带 # 号
   * createWebHistory 不带 # 号
   */
  history: createWebHistory(),
  // 下面这个 可以写成ES6的简写 routers
  routes: routes
})

export default router